import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-copy-decision',
  templateUrl: './copy-decision.component.html',
  styleUrls: ['./copy-decision.component.scss']
})
export class CopyDecisionComponent extends BaseComponent implements OnInit {
  @Input() enabledCopy: boolean;
  @Input() tooltip: string = 'forms.common.Criteria.copy';
  @Input() prefix: string = '';
  @Output() clicked = new EventEmitter();
  constructor() { super(); }

  ngOnInit() {
  }

  clickedBtn() { this.clicked.emit(); }

}
